<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt" >{{question}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt" *ngIf="!isRenewal">{{question_q1}}</h1>
    <!-- <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
    <div class="form-check mb-2" *ngFor="let term of terms; let i= index">
      <input type="checkbox" class="form-check-input mgntp10" id="{{i}}" value="{{term.term}}" name="term" [(ngModel)]="term.value"
        (click)="getTerm(term.term, i)" />
      <label class="form-check-label font20" for="{{i}}">{{term.term}}</label>
    </div>
  </div> -->
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
      <div class="form-group row">
        <label class="col-sm-5 col-form-label font18 pl-5">Term</label>
        <div class="col-sm-7 px-0 mt-1">
          <!-- <select (change)="getTerm($event);" [(ngModel)]="term_length" class="dropdown-toggle form-control">
            <option *ngFor="let term of terms" value={{term.term}}>{{term.term}}</option>
          </select> -->
          <ng-select [items]="terms" bindLabel="term"
          bindValue="term" placeholder="Select" [searchable]="false" [clearable]="false"
            (change)="getTerm(term_length);" [(ngModel)]="term_length">
          </ng-select>
        </div>
      </div>
    </div>
    <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">{{buttonText}}</button>
    <!-- <p class="text-success mt-3" *ngIf="showTip">{{questionObj.tip}}</p> -->
    <div >
      <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">PRO TIP</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">PRO TIP<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-12 m-auto">
    <div class="form-group col-12 px-0 mt-2 d-flex flex-wrap" style="margin-bottom:6px !important">
      <label class="col-5 col-form-label text-right">Term</label>
      <div class="col-7 px-0 mt-1">
        <!-- <select (change)="getTerm($event);" [(ngModel)]="term_length" class="dropdown-toggle form-control">
          <option *ngFor="let term of terms" value={{term.term}}>{{term.term}}</option>
        </select> -->
        <ng-select [items]="terms" bindLabel="term"
        bindValue="term" placeholder="Select" [searchable]="true" [clearable]="false"
          (change)="getTerm(term_length);" [(ngModel)]="term_length">
        </ng-select>
      </div>
    </div>
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right mt-2 mb-2" >
        <h1 class="ansMob text-right">{{term_length}}</h1>
      </div>
    </div>
    <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
          <p class="text-center tiphead">PRO TIP</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">PRO TIP<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngStyle]="{'display':display}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active26.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active19.png"></span>
    <h5 class="clr333 processtxt">100% Completed</h5>
  </div>
</div> -->